export default "__VITE_ASSET__4031dddd__"